const routes = [
  // 其他路由
  {
    path: '/:pathMatch(.*)*',
    name: 'LoginView',
    redirect: '/login',
    meta: {
      title: '登录',
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/basic/login'),
    meta: {
      title: '登录',
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/basic/register'),
    meta: {
      title: '注册',
    },
  },
  {
    path: '/basic',
    name: 'Basic',
    component: () => import('@/views/basic'),
    meta: {
      title: '硕汉云',
    },
    children: [
      {
        path: '/home',
        name: 'HOME',
        meta: {
          title: '首页',
        },
        component: () => import('@/views/home'),
      },
      {
        path: '/accountInfo',
        name: 'AccountInfo',
        meta: {
          title: '账户信息',
        },
        component: () => import('@/views/account/info'),
      }
    ],
  },
]

export default routes
